import { InlineFeedback } from '../../feedback/index.js';
import { useFeedback } from '../../feedback/index.js';
import { useEffect, useRef, useState } from 'react';
import { CONTENT_EDITOR_HOST_LOAD_META } from './useContentEditorKernel.js';

function acceptedHref(value) {
  const href = value.trim();
  if (!href || /[\u0000-\u0020]/.test(href)) return null;
  if (/^(https?:\/\/|mailto:|tel:|\/|#)/i.test(href) && !href.startsWith('//')) return href;
  return null;
}

export function ContentEditorLinkControl({ editor, disabled = false }) {
  const toast = useFeedback();
  const [open, setOpen] = useState(false);
  const [href, setHref] = useState('');
  const [error, setError] = useState('');
  const bookmark = useRef(null);
  useEffect(() => {
    if (!editor) return;
    const map = ({ transaction }) => {
      if (transaction.getMeta(CONTENT_EDITOR_HOST_LOAD_META)) {
        bookmark.current = null;
        setOpen(false); setHref(''); setError('');
        return;
      }
      bookmark.current = bookmark.current?.map(transaction.mapping);
    };
    editor.on('transaction', map);
    return () => editor.off('transaction', map);
  }, [editor]);
  const restoreSelection = () => {
    if (!editor?.isEditable || disabled || !bookmark.current) return false;
    try { editor.view.dispatch(editor.state.tr.setSelection(bookmark.current.resolve(editor.state.doc))); return true; }
    catch { toast.error('The selected text is no longer available.', { id: 'action:ContentEditorLinkControl:restoreSelection' }); return false; }
  };
  return <>
    <button type="button" disabled={!editor?.isEditable || disabled} aria-pressed={editor?.isActive('link') || false} onMouseDown={(event) => event.preventDefault()} onClick={() => { bookmark.current = editor.state.selection.getBookmark(); setHref(editor.getAttributes('link').href || 'https://'); setError(''); setOpen(true); }}>Link</button>
    {open ? <form aria-label="Edit link" onSubmit={(event) => {
      event.preventDefault();
      const url = acceptedHref(href);
      if (!url) { setError('Enter an HTTPS, HTTP, email, phone, or relative link.'); return; }
      if (restoreSelection() && editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()) setOpen(false);
    }}>
      <label>Link URL<input autoFocus type="text" value={href} onChange={(event) => setHref(event.target.value)}/></label>
      <button type="submit" disabled={!editor?.isEditable || disabled}>Apply link</button>
      <button type="button" disabled={!editor?.isEditable || disabled} onClick={() => { if (restoreSelection()) { editor.chain().focus().extendMarkRange('link').unsetLink().run(); setOpen(false); } }}>Remove link</button>
      <button type="button" onClick={() => setOpen(false)}>Cancel link</button>
      {error ? <InlineFeedback variant="error" role="alert">{error}</InlineFeedback> : null}
    </form> : null}
  </>;
}
